import React, { useEffect } from "react";
import ListDetailsSubLayout from "../../layout/ListDetailSubLayout";
import applicationStore from "../../stores/application";
import commonStore from "../../stores/common";
import Application from "./components/Application";
import ApplicationDetails from "./components/ApplicationDetails";

const ApplicationPage = () => {
  useEffect(() => {
    return () => {
      applicationStore.getState().reset();
      commonStore.getState().reset();
    };
  }, []);

  return (
    <ListDetailsSubLayout
      detailsComponent={ApplicationDetails}
      listComponent={Application}
    />
  );
};

export default ApplicationPage;
